export default class BlockGallerySlider {
	static init() {
		let swipers = document.querySelectorAll('.block-gallery-swiper');

		swipers.forEach( (swiper) => {
			let swiperElement =  new Swiper(swiper, {
				spaceBetween: 0,
				centeredSlides: true,
				speed: 4000,
				autoplay: {
					delay: 0,
					pauseOnMouseEnter: true,
					disableOnInteraction: false,
				},
				loop: true,
				slidesPerView:'auto'
			});

		});
	}
}
